export default "__VITE_ASSET__DLB0iPVy__"